// import states
import {
	EligibilityMessagePrioritiesState,
	MinCostPerSquareFootVersionsState,
	getInitialEligibilityMessagePrioritiesState,
	getInitialMinCostPerSquareFootVersionsState,
} from '@app/redux/states';

interface AdministratorState {
	eligibilityMessagePrioritiesState: EligibilityMessagePrioritiesState;
	minCostPerSquareFootVersionsState: MinCostPerSquareFootVersionsState;
};

const getInitialState = (): AdministratorState => {
	return {
		eligibilityMessagePrioritiesState: getInitialEligibilityMessagePrioritiesState(),
		minCostPerSquareFootVersionsState: getInitialMinCostPerSquareFootVersionsState(),
	};
};

export { getInitialState, AdministratorState };